import React from 'react'
import { Flex } from '@instacart/ids-core'
import { Tooltip, Marker } from '@retailer-platform/shared-components/src/tds'
import { useDashMessages } from '../../../../intl/intl.hooks'
import { useIsReadOnly } from '../../../utils/access/useIsReadOnly'
import {
  useHasWriteAccessForCurrentPartner,
  useIsPartnerWriteAccessRequired,
} from '../../../utils/access/usePartnerWriteAccess.hooks'
import { useCurrentAccountContext } from '../../../../utils/current-account/CurrentAccountContext'
import { navBarHeight } from './navBar.constants'

export const NavWriteAccessIndicator: React.FunctionComponent<{}> = () => {
  const i18n = useDashMessages({
    readOnlyLabel: 'partnerWriteAccess.navMarker.readOnlyLabel',
    readOnly: 'partnerWriteAccess.navMarker.readOnly',
    noPartnerWriteAccess: 'partnerWriteAccess.navMarker.noAccess',
  })
  const { account } = useCurrentAccountContext()
  const isReadOnly = useIsReadOnly()
  const isPartnerWriteAccessRequired = useIsPartnerWriteAccessRequired()
  const hasWriteAccessForCurrentPartner = useHasWriteAccessForCurrentPartner()

  if (
    !account?.isInternal ||
    !isPartnerWriteAccessRequired ||
    (hasWriteAccessForCurrentPartner && !isReadOnly)
  ) {
    return null
  }

  const tooltipText = isReadOnly ? i18n.readOnly : i18n.noPartnerWriteAccess

  return (
    <div>
      <Tooltip label={tooltipText} position="bottom">
        <Flex
          css={{
            cursor: 'not-allowed',
            alignItems: 'center',
            justifyContent: 'center',
            height: navBarHeight,
          }}
        >
          <Marker text={i18n.readOnlyLabel} variant="alert" />
        </Flex>
      </Tooltip>
    </div>
  )
}
